import React, {useRef, useEffect, useState, useContext} from 'react';
import {Handle} from 'reactflow';
//import {Handle} from 'react-flow-renderer';
import {useSelector, shallowEqual} from 'react-redux';
import Select from 'react-select';

import {Chatbot} from '../../states/actions';
import {onEdit, onSetStart, onClose, onRemove, isLightColor} from '../../helpers/block-helper';
import {ColorPicker} from '../ColorPicker';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import {User} from '../../states/actions';
import ClassicEditor from 'ckeditor5-custom-build';
import {InputComponent, SelectComp, TextareaComponent, PreviewComponent, NodeComponent} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';
import {axios} from '../../libs';


export const SubscriptionBlock = React.memo((node) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);  


  const {block, start, review, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress};
  const optionSelectRef = useRef(null);
  const {_id} = useSelector(User.get());

  const [previewMode, setPreviewMode] = useState(globalState.preview ? undefined : false);

  useEffect(() => {
    setPreviewMode(globalState.preview);
}, [globalState.preview]);

  if (!block) {
    return null;
  }


  const variableOptions = Chatbot.getBlockVariables();
  const {
    data,
  } = block;
  const {backgroundColor: bgColor, textColor: txtColor} = data.meta;
  const backgroundColor = bgColor ?? '#2a3f54';
  const textColor = txtColor ?? (isLightColor(backgroundColor) ? '#000000' : '#ffffff');

  return (
    <>
      {!previewMode &&(
        <NodeComponent bot={bot} block={block} name="Subscription" icon="payment" data={data} node={node} start={start} />

      )}
      {previewMode &&(
        // <div className={`block-body node`} onClick={review ? null : () => onEdit(node)}>
         <PreviewComponent bot={bot} data={data} node={node} start={start}/>
        // </div>

      )}
    </>
  );
});


export const SubscriptionEditor = ({nodeid, block, data, variableoptions}) => {

  const [crmUsers, setCrmUsers] = useState([]);
  const [crmUsersLoading, setCrmUsersLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchCrmUsers = async () => {
      try {
        setCrmUsersLoading(true);
        const users = await axios.get('/projects/crm-users/all');
        if (!cancelled) {
          setCrmUsers(Array.isArray(users) ? users.filter((u) => u.role === 'lawyer') : []);
        }
      } catch (err) {
        console.error('Error fetching CRM users for subscription block:', err);
      } finally {
        if (!cancelled) {
          setCrmUsersLoading(false);
        }
      }
    };
    fetchCrmUsers();
    return () => {
      cancelled = true;
    };
  }, []);

  const partnerOptions = crmUsers.map((user) => ({
    label: `${user.firstName} ${user.lastName}${user.partner_company_name ? ` (${user.partner_company_name})` : ''}`,
    value: user.user_no,
    content: user.user_no,
  }));

  let plan = [
    {
      label: 'Annual',
      value: 'annual',
      content: 'annual',
    },
    {
      label: 'Monthly',
      value: 'monthly',
      content: 'monthly',
    },
      {
      label: 'Daily',
      value: 'daily',
      content: 'daily',
    },
      {
      label: '5 minute',
      value: 'min5',
      content: 'min5',
    },
  ];

    const handleBlur = (e) => {   
      Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
    };
 
    return (
      <>
         

            <div className='section'>Subscription</div>

            {/* <SelectComp data={data} name="Select Plan" dataname="plan" placeholder="Select" options={plan} block={block} value="value"/> */}

            <SelectComp data={data} name="Plan" dataname="plan" placeholder="Select" options={variableoptions} block={block} value="label"/>



            <br/><br/>


            <SelectComp data={data} name="First Name" dataname="first_name" placeholder="Select" options={variableoptions} block={block} value="label"/>
          
            <SelectComp data={data} name="Last Name" dataname="last_name" placeholder="Select" options={variableoptions} block={block} value="label"/>

            <SelectComp data={data} name="Email" dataname="email" placeholder="Select" options={variableoptions} block={block} value="label"/>

            <br/><br/>
            <div className='section'>SERVICE PROVIDER</div>

            <SelectComp
              data={data}
              name="Partner"
              dataname="partner_id"
              placeholder={crmUsersLoading ? 'Loading...' : 'Select partner'}
              options={partnerOptions}
              block={block}
              value="value"
            />

            <InputComponent
              data={data}
              name="Payment description"
              dataname="payment_description"
              onBlur={handleBlur}
            />
            <small className="text-muted">Use {'{variable_name}'} for chat variables</small>

      </>
    )
}
